import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Footer.st.css.js';
import { dataHooks } from '../../constants';
import Divider from '../../../Divider';
class Footer extends PureComponent {
    render() {
        const { children, className, showDivider, noPadding } = this.props;
        return (React.createElement("div", { className: st(classes.root, {}, className), "data-hook": dataHooks.sidePanelFooter },
            showDivider && (React.createElement(Divider, { className: classes.divider, dataHook: dataHooks.sidePanelHeaderDivider })),
            React.createElement("div", { className: st(classes.footerContainer, {
                    noPadding,
                }) }, children)));
    }
}
Footer.displayName = 'Footer';
Footer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    showDivider: PropTypes.bool,
    noPadding: PropTypes.bool,
};
Footer.defaultProps = {
    showDivider: true,
    noPadding: false,
};
export default Footer;
//# sourceMappingURL=Footer.js.map